<template>
  <div class="scrolling-box">
    <b-container style="padding-left: 0.5rem; padding-right: 0.5rem">
      <div
        class="d-flex justify-content-between"
        style="overflow: auto; white-space: nowrap; margin: 35px"
      >
        <b-col style="padding: 0.2rem; text-align: center">
          <b-button
            class="col-md-8 col-12"
            variant="msstreamblue"
            style="padding: 6px"
            @click="emitNewProject()"
          >
            <font-awesome-layers style="margin-right:2px">
              <font-awesome-icon icon="play" transform="shrink-9" />
              <font-awesome-icon :icon="['far', 'comment-alt']" transform="grow-4 down-2" />
            </font-awesome-layers> 
            New project</b-button
          >
        </b-col>
      </div>
    </b-container>

    <b-container>
      <div class="greysearch">
        <b-form @submit.prevent="onSearchBar">
          <b-form-group style="margin-bottom: 3px">
            <b-input-group>
              <b-input-group-prepend
                ><b-button
                  type="submit"
                  class="input-group-text"
                  variant="db-sb"
                  ><font-awesome-icon
                    icon="search"
                  ></font-awesome-icon></b-button
              ></b-input-group-prepend>
              <b-form-input
                v-model="search"
                @input="startTimeoutSearch"
              ></b-form-input>
              <b-input-group-append id="popover-help" style="cursor: pointer"
                ><b-input-group-text>
                  <font-awesome-icon
                    icon="question-circle"
                  ></font-awesome-icon> </b-input-group-text
              ></b-input-group-append>
              <b-popover
                target="popover-help"
                title="Help with searchbar"
                triggers="hover"
                placement="bottomleft"
                variant="light"
              >
              Filter on title and description by default (if no keyword mentioned).<br /> 
              Keywords for specific search are: title, owner, description.<br /> 
              Use '+' to cumulate several parameters for one keyword. Ex: description:football+tennis. <br />
              Use a space to make a search combining more than one criteria. Ex: title:MyProject description:vacation+summer.
              </b-popover>
            </b-input-group>
            <p
              style="
                text-align: center;
                margin-bottom: 0px;
                margin-top: 0.5rem;
                font-size: 90%;
              "
            >
              Filter: <strong>'{{ search }}'</strong> -> Result:
              <strong>{{ numberOfProjects }}</strong
              >/{{ totalNumberOfProjects }} project(s)
            </p>
          </b-form-group>
        </b-form>
      </div>

      <b-row
        class="justify-content-between align-items-center"
        style="
          margin-right: 0px;
          margin-left: 0px;
          margin-top: 35px;
          margin-bottom: 15px;
        "
      >
        <b-button-group class="c1">
          <b-button
            style="margin-right: 5px"
            :variant="thOrList === 0 ? 'greenw' : 'darkblue'"
            @click="
              thOrList = 0;
              saveListParam();
            "
            title="Mosaic"
          >
            <font-awesome-icon :icon="['fas', 'th']"></font-awesome-icon>
          </b-button>
          <!--
          <b-button
            style="margin-right: 5px"
            :variant="thOrList === 1 ? 'greenw' : 'darkblue'"
            @click="
              thOrList = 1;
              saveListParam();
            "
            title="List"
          >
            <font-awesome-icon :icon="['fas', 'list']"></font-awesome-icon>
          </b-button>
          
          <b-button
            v-if="$auth.getMyUser().client_infos[0].oldTable"
            style="margin-right: 5px"
            :variant="thOrList === 2 ? 'greenw' : 'darkblue'"
            @click="
              thOrList = 2;
              saveListParam();
            "
            title="Old List"
          >
            <font-awesome-icon :icon="['fas', 'bars']"></font-awesome-icon>
          </b-button>
          -->
        </b-button-group>
        <b-dropdown
          style="z-index: 2"
          id="dropdown-3"
          v-bind:text="numberPerPage + ' per page'"
          variant="greenw"
          size="sm"
        >
          <b-dropdown-item
            v-bind:class="numberPerPage === 12"
            @click="
              numberPerPage = 12;
              currentPage = 1;
              getProjects();
            "
            >12</b-dropdown-item
          >
          <b-dropdown-item
            v-bind:class="numberPerPage === 20"
            @click="
              numberPerPage = 20;
              currentPage = 1;
              getProjects();
            "
            >20</b-dropdown-item
          >
          <b-dropdown-item
            v-bind:class="numberPerPage === 50"
            @click="
              numberPerPage = 50;
              currentPage = 1;
              getProjects();
            "
            >50</b-dropdown-item
          >
          <b-dropdown-item
            v-bind:class="numberPerPage === 100"
            @click="
              numberPerPage = 100;
              currentPage = 1;
              getProjects();
            "
            >100</b-dropdown-item
          >
        </b-dropdown>
        <b-button
          style="margin-left: 5px"
          variant="mswarning"
          @click="
            getProjects();
            getNumberProjectPlatform();
          "
          title="Refresh list"
        >
          <font-awesome-icon :icon="['fas', 'sync']"></font-awesome-icon>
        </b-button>
      </b-row>
    </b-container>

    <b-container>
      <b-row v-if="isGetInProgress" class="justify-content-center">
        <fade-loader
          color="#f98e35"
          style="
            position: relative;
            width: 45px;
            height: 60px;
            margin: auto;
            text-align: center;
          "
        ></fade-loader>
      </b-row>

      <div class="scrollmenu" style="padding-bottom: 5px">
        <b-button
          style="margin-left: 2px; margin-right: 2px"
          @click="changeActiveSort('nameLowerCase')"
          :variant="activeSort === 'nameLowerCase' ? 'greenw' : 'darkblue'"
          size="sm"
        >
          Title
          <font-awesome-icon
            v-if="activeSort === 'nameLowerCase' && activeSortOrder === -1"
            :icon="['fas', 'sort-alpha-up']"
          ></font-awesome-icon>
          <font-awesome-icon
            v-if="activeSort === 'nameLowerCase' && activeSortOrder === 1"
            :icon="['fas', 'sort-alpha-down']"
          ></font-awesome-icon>
        </b-button>

        <b-button
          style="margin-left: 2px; margin-right: 2px"
          @click="changeActiveSort('user')"
          :variant="activeSort === 'user' ? 'greenw' : 'darkblue'"
          size="sm"
        >
          Owner
          <font-awesome-icon
            v-if="activeSort === 'user' && activeSortOrder === -1"
            :icon="['fas', 'sort-alpha-up']"
          ></font-awesome-icon>
          <font-awesome-icon
            v-if="activeSort === 'user' && activeSortOrder === 1"
            :icon="['fas', 'sort-alpha-down']"
          ></font-awesome-icon>
        </b-button>

        <b-button
          style="margin-left: 2px; margin-right: 2px"
          @click="changeActiveSort('createdDate')"
          :variant="activeSort === 'createdDate' ? 'greenw' : 'darkblue'"
          size="sm"
        >
          <font-awesome-icon
            :icon="['fas', 'calendar-minus']"
          ></font-awesome-icon>
          Creation date
          <font-awesome-icon
            v-if="activeSort === 'createdDate' && activeSortOrder === -1"
            :icon="['fas', 'sort-numeric-up']"
          ></font-awesome-icon>
          <font-awesome-icon
            v-if="activeSort === 'createdDate' && activeSortOrder === 1"
            :icon="['fas', 'sort-numeric-down']"
          ></font-awesome-icon>
        </b-button>

        <b-button
          style="margin-left: 2px; margin-right: 2px"
          @click="changeActiveSort('lastUpdated')"
          :variant="activeSort === 'lastUpdated' ? 'greenw' : 'darkblue'"
          size="sm"
        >
          <font-awesome-layers>
            <font-awesome-icon
              :icon="['fas', 'circle']"
              transform="shrink-12"
            />
            <font-awesome-icon :icon="['fas', 'redo-alt']" />
          </font-awesome-layers>
          Last update
          <font-awesome-icon
            v-if="activeSort === 'lastUpdated' && activeSortOrder === -1"
            :icon="['fas', 'sort-numeric-up']"
          ></font-awesome-icon>
          <font-awesome-icon
            v-if="activeSort === 'lastUpdated' && activeSortOrder === 1"
            :icon="['fas', 'sort-numeric-down']"
          ></font-awesome-icon>
        </b-button>
      </div>

      <b-row class="justify-content-center align-items-center mt-4 mb-4">
        <b-col cols="12">
          <h5 v-if="search === ''" style="text-align: center">
            All projects sorted by '<span style="color: #14bf98">{{activeSortMsg}}</span>'
          </h5>
          <h5 v-else style="text-align: center">
            Projects filtered with '<span style="color: #14bf98">{{
              search
            }}</span
            >' and sorted by '<span style="color: #14bf98">{{
              activeSortMsg
            }}</span
            >' -> <strong>{{ numberOfProjects }}</strong
            >/{{ totalNumberOfProjects }} project(s)
          </h5>
        </b-col>
      </b-row>

      <div v-if="thOrList === 0">
        <b-row>
          <div
            class="col-lg-3 col-md-4 col-sm-6 col-12 mycard2"
            v-for="project in projects"
            v-bind:key="project.uuid"
          >
            <div style="margin-top: 8px">
              <b-row class="align-items-center h-100">
                <b-col
                  v-if="!project._modifyTitle"
                  cols="10"
                  class="pointerEltVideo"
                  style="margin: 0px; padding-left: 15px"
                  @click="startProject(project)"
                  :title="
                    'Click to open ' +
                    project.name +
                    ' project page'
                  "
                >
                  <h5
                    style="
                      margin: 8px 0;
                      padding: 0 0 3px;
                      border-bottom: 1px solid #2f90b0;
                      border-radius: 0;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                    "
                  >
                    {{ project.name }}
                  </h5>
                </b-col>

                <b-col
                  v-if="(!project._modifyTitle) && (project.user === $auth.getMyUser().username)"
                  cols="1"
                  class="pointerEltVideo"
                  style="margin: 0px; padding: 0px"
                  @click="
                    project._modifyTitle = true;
                    projects = projects.splice(0);
                    project._title = project.name;
                  "
                  title="Modify title"
                >
                  <font-awesome-icon
                    class="pointerEltVideo"
                    style="padding: 0px"
                    :icon="['fas', 'pencil-alt']"
                  ></font-awesome-icon>
                </b-col>

                <b-col
                  v-if="project._modifyTitle"
                  cols="11"
                  class="pointerEltVideo"
                  style="margin: 0px; padding-top:0px; padding-bottom:0px; padding-left: 15px"
                  :title="
                    'Click to open ' +
                    project.name +
                    ' project page'
                  "
                >
                  <b-form
                    @submit.prevent="updateTitle(project)"
                    style="margin-top: 5px; margin-bottom: 5px"
                  >
                    <b-input-group>
                      <b-input type="text" v-model="project._title"></b-input>
                      <b-input-group-append
                        style="align-items: center; justify-content: flex-end"
                      >
                        <b-button
                          variant="bordered"
                          @click="updateTitle(project)"
                          type="submit"
                        >
                          <font-awesome-icon
                            class="pointerEltSB"
                            style="color: #14bf98"
                            :icon="['fas', 'check']"
                          />
                        </b-button>
                        <b-button
                          variant="borderedx"
                          @click="
                            project._title = project.name;
                            project._modifyTitle = false;
                            projects = projects.splice(0);
                          "
                        >
                          <font-awesome-icon
                            class="pointerEltSB"
                            style="color: red"
                            :icon="['fas', 'times']"
                          />
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form>
                </b-col>

                <b-col
                  cols="1"
                  class="pointerEltVideo"
                  style="margin: 0px; padding: 0px; text-align:right"
                  @click="
                    projectToDelete = project;
                    showModal('confirmDelete');
                  "
                  :title="'Remove ' + project.name + ''"
                >
                  <font-awesome-icon
                    class="pointerEltVideo"
                    style="color: red; padding: 0px"
                    :icon="['fas', 'trash']"
                  ></font-awesome-icon>
                </b-col>
              </b-row>

              <b-row
                :title="
                  'Owner of the project: ' +
                  project.user +
                  ' (click to see all project details)'
                "
                @click="startProject(project)"
              >
                <b-col cols="12">
                  <p
                    style="
                      padding-bottom: 5px;
                      margin-bottom: 10px;
                      color: #2a5d77;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                    "
                    v-if="project.user && project.user !== ''"
                  >
                    By<strong> {{ project.user }}</strong>
                  </p>
                </b-col>
              </b-row>

              <b-row class="justify-content-center">
                <div class="previewContainer" style="z-index: 1">
                  <!--<b-img @click="startProject(project)" class="previewImg" style="object-fit:cover; cursor:pointer" :src="`${baseurl[video.type]}/contents/${(video.encodingStatus === 'segmented') ? 'passthrough' : 'encodings'}/${video.type}/${video.uuid}/thumbnail.jpg`" @error="imgUrlAlt" title="Click on the image to open project" fluid></b-img>
                  -->
                  <b-img
                    @click="startProject(project)"
                    class="previewImg"
                    style="object-fit: contain; cursor: pointer"
                    :src="project.manifestVideo.thumbnail"
                    @error="imgUrlAlt"
                    title="Click on the image to open project"
                    fluid
                  ></b-img>
                </div>
              </b-row>

              <b-row
                @click="startProject(project)"
                title="Click to see project details"
              >
                <b-col
                  style="margin: 10px 0px; padding: 3px; text-align: center"
                  cols="6"
                  title="Creation date"
                >
                  <small>
                    <font-awesome-icon
                      :icon="['fas', 'calendar-minus']"
                    ></font-awesome-icon>
                    {{ project.createdAt }}
                  </small>
                </b-col>
                <b-col
                  style="margin: 10px 0px; padding: 3px; text-align: center"
                  cols="6"
                  title="Last update date"
                >
                  <small>
                    <font-awesome-layers>
                      <font-awesome-icon
                        :icon="['fas', 'circle']"
                        transform="shrink-12"
                      />
                      <font-awesome-icon :icon="['fas', 'redo-alt']" />
                    </font-awesome-layers>
                    {{project.lastUpdatedFormat}}
                    <span v-if="project.lastUpdatedFormat === project.createdAt" title="Never modified"><small>*</small></span>
                  </small>
                </b-col>
              </b-row>
              <div
                style="
                  padding-top: 7px;
                  padding-bottom: 7px;
                  border-top: 1px solid #2a5d77;
                  border-bottom: 1px solid #2a5d77;
                "
              >
                <p
                  style="
                    margin-bottom: 10px;
                    color: #2a5d77;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                  "
                >
                  Current version: <strong>v{{ project.lastVersion }}</strong>
                </p>
                <p
                  style="
                    margin-bottom: 10px;
                    color: #2a5d77;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                  "
                  title="Video file of the project current version"
                >
                  <font-awesome-icon :icon="['fas', 'film']" />
                  {{ project.videoTitleLastVersion }}
                </p>
                <p
                  style="margin-bottom: 10px; color: #2a5d77"
                  title="Number of project collaborators and teams"
                >
                  <font-awesome-icon :icon="['fas', 'user-tie']" />
                  {{ project.numberOfCollabs }}&nbsp;&nbsp;
                  <font-awesome-icon :icon="['fas', 'user-friends']" />
                  {{ project.teams.length }}
                </p>
                <p
                  style="margin-bottom: 10px; color: #2a5d77"
                  title="Number of annotations, commented annotations and comments in the project"
                >
                  <font-awesome-icon
                    :icon="['fas', 'highlighter']"
                    transform="flip-h shrink-2"
                  />
                  {{ project.annotations }}&nbsp;&nbsp;
                  <small
                    ><font-awesome-layers>
                      <font-awesome-icon
                        :icon="['fas', 'highlighter']"
                        transform="flip-h shrink-3 left-5"
                      />
                      <font-awesome-icon
                        :icon="['fas', 'comment-dots']"
                        transform="shrink-3 up-5 right-4"
                      /> </font-awesome-layers
                  ></small>
                  {{ project.annotationsWithComments }}&nbsp;&nbsp;
                  <font-awesome-icon :icon="['fas', 'comment-dots']" />
                  {{ project.comments }}&nbsp;
                </p>
              </div>

            <b-row v-if="!project._modifyDescription" class="pointerEltVideo" @click="project._modifyDescription = !project._modifyDescription; project._desc=project.description; projects=projects.splice(0)" style="margin-top:10px" title="Project description, click to modify">
              <b-col cols="12">
                <p style="margin-bottom:5px" v-if="project.description && project.description !== ''">
                  <small><font-awesome-layers>
                    <font-awesome-icon :icon="['fas', 'file-alt']" />
                    <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180" />
                  </font-awesome-layers>
                  &nbsp;{{project.description}}</small>
                </p>
                <p style="margin-bottom:5px" v-else>
                  <small><font-awesome-layers>
                    <font-awesome-icon :icon="['fas', 'file-alt']" />
                    <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180" />
                  </font-awesome-layers>
                  &nbsp;-</small>
                </p>
              </b-col>
            </b-row>

            <b-row class="align-items-center" v-if="project._modifyDescription" title="Video description modification">
              <b-col cols="10">
                <b-form @submit.prevent="updateDescription(project)">
                  <b-form-textarea
                  id="textarea"
                  v-model="project._desc"
                  placeholder="Write description here"
                  rows="1"
                  max-rows="2"
                  style="font-size:85%; margin-top:5px; margin-bottom:5px"
                  ></b-form-textarea>
                </b-form>
              </b-col>
              <b-col cols="2" style="padding:0px; margin-left:-10px">
                <b-button variant="emptyB" @click="updateDescription(project);">
                  <small><font-awesome-icon style="color:#14BF98" :icon="['fas', 'check']" /></small>
                </b-button>
                <b-button variant="emptyB" @click="project._modifyDescription = false; project._desc=project.description; projects = projects.splice(0)">
                  <small><font-awesome-icon style="color:red" :icon="['fas', 'times']" /></small>
                </b-button>
              </b-col>
            </b-row>


              <!--<p
                class="pointerEltVideo"
                style="
                  margin-top: 10px;
                  margin-bottom: 10px;
                  padding-top: 5px;
                  padding-bottom: 5px;
                  color: #2a5d77;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                "
                :title="'Project description: ' + project.description"
              >
                <small>
                  <font-awesome-layers>
                    <font-awesome-icon :icon="['fas', 'file-alt']" />
                    <font-awesome-icon
                      :icon="['fas', 'pencil-alt']"
                      transform="shrink-4 up-10 right-6 flip-v rotate-180"
                    /> </font-awesome-layers></small
                >&nbsp;
                {{ project.description }}
              </p>-->
            </div>
          </div>
        </b-row>
      </div>

      <div v-if="thOrList === 1">
        <b-row
          class="cardList2 col-12 align-items-center h-100"
          style="
            display: flex;
            overflow: auto;
            white-space: nowrap;
            padding: 0%;
            margin: 0px 0px 5px 0px;
          "
          v-for="project in projects"
          v-bind:key="project.uuid"
        >
          <b-row class="align-items-center h-100">
            <b-col cols="2" style="width: 1100px">
              <div class="previewContainer2" style="z-index: 1">
                <b-img
                  class="previewImg"
                  style="object-fit: contain; cursor: pointer"
                  :src="project.manifestVideo.thumbnail"
                  @error="imgUrlAlt"
                  title="Click on the image to open project"
                  fluid
                ></b-img>
              </div>
            </b-col>

            <b-col
              cols="3"
              style="padding: 0px 15px; border-right: 2px solid #2a5d77"
            >
              <b-row style="margin-bottom: 5px">
                <font-awesome-icon
                  class="pointerElt"
                  style="color: red; margin-right: 1rem"
                  :icon="['fas', 'trash']"
                  title="Delete"
                  @click="
                    projectToDelete = project;
                    showModal('confirmDelete');
                  "
                ></font-awesome-icon>
              </b-row>

              <b-row
                v-if="!project._modifyTitle"
                class="align-items-center"
                style="padding-left: 0px"
              >
                <b-col
                  cols="10"
                  class="pointerEltVideo"
                  style="padding: 0px; margin: 0px"
                  @click="startProject(project)"
                  :title="
                    'Click to open ' +
                    project.name +
                    ' project page'
                  "
                >
                  <h6
                    style="
                      margin: 4px 2px 4px 0px;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                    "
                  >
                    {{ project.name }}
                  </h6>
                </b-col>
                <b-col
                  cols="1"
                  class="pointerEltVideo"
                  style="padding: 0px"
                  @click="
                    project._modifyTitle = true;
                    projects = projects.splice(0);
                    project._title = project.name;
                  "
                  title="Click to modify title"
                >
                  <h6 style="text-align: center">
                    <small
                      ><font-awesome-icon
                        :icon="['fas', 'pencil-alt']"
                      ></font-awesome-icon
                    ></small>
                  </h6>
                </b-col>
              </b-row>

              <b-row
                v-if="project._modifyTitle"
                class="align-items-center"
                style="padding-left: 0px"
                title="Video title modification"
              >
                <b-col
                  cols="12"
                  style="
                    padding-left: 0px;
                    padding-right: 0px;
                    margin-left: 0px;
                  "
                >
                  <b-form
                    @submit.prevent="updateTitle(project)"
                    style="margin-top: 5px; margin-bottom: 5px"
                  >
                    <b-input-group>
                      <b-input type="text" v-model="project._title"></b-input>
                      <b-input-group-append
                        style="align-items: center; justify-content: flex-end"
                      >
                        <b-button
                          variant="empty"
                          @click="updateTitle(project)"
                          type="submit"
                        >
                          <font-awesome-icon
                            style="color: #14bf98"
                            :icon="['fas', 'check']"
                          />
                        </b-button>
                        <b-button
                          variant="empty"
                          @click="
                            project._title = project.name;
                            project._modifyTitle = false;
                            projects = projects.splice(0);
                          "
                        >
                          <font-awesome-icon
                            style="color: red"
                            :icon="['fas', 'times']"
                          />
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form>
                </b-col>
              </b-row>

              <b-row
                @click="startProject(project)"
                :title="
                  'Owner of the project: ' +
                  project.user +
                  ' (click to see all project details)'
                "
              >
                <p
                  style="
                    margin-bottom: 2px;
                    color: #2a5d77;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                  "
                  v-if="project.user && project.user !== ''"
                >
                  <small
                    >By <strong>{{ project.user }}</strong></small
                  >
                </p>
              </b-row>

              <b-row
                class="justify-content-around"
                @click="startProject(project)"
                title="Click to see project details"
              >
                <p
                  style="
                    color: #2a5d77;
                    margin: 2px 30px 0px 0px;
                    border: 1px solid transparent;
                    border-radius: 0.1rem;
                    padding: 1px;
                  "
                  title="Project creation date (click to see all project details)"
                >
                  <small
                    ><font-awesome-icon
                      :icon="['fas', 'calendar-minus']"
                    ></font-awesome-icon>
                    {{ project.createdAt }}</small
                  >
                </p>
              </b-row>

              <b-row
                class="justify-content-around"
                @click="startProject(project)"
                title="Click to see project details"
              >
                <p
                  style="
                    color: #2a5d77;
                    margin: 2px 30px 0px 0px;
                    border: 1px solid transparent;
                    border-radius: 0.1rem;
                    padding: 1px;
                  "
                  title="Project last updated date (click to see all project details)"
                >
                  <small>
                    <font-awesome-layers>
                      <font-awesome-icon
                        :icon="['fas', 'circle']"
                        transform="shrink-12"
                      />
                      <font-awesome-icon :icon="['fas', 'redo-alt']" />
                    </font-awesome-layers>
                    {{ project.lastUpdated }}
                    <span v-if="project.lastUpdated === project.createdAt"><small>*</small></span>
                  </small>
                </p>
              </b-row>
            </b-col>
          </b-row>
        </b-row>
      </div>
    </b-container>

    <b-pagination
      v-if="projects.length !== undefined && projects.length > 2"
      align="center"
      :limit="8"
      :total-rows="realTotalNumberOfPage"
      v-model="currentPage"
      :per-page="1"
      first-number last-number
      @input="getProjects()"
    ></b-pagination>

    <b-row v-if="realTotalNumberOfPage > 10 && projects.length !== undefined && projects.length > 2" style="margin-right: 0px">
      <b-col cols="10" xs="8" md="8" lg="3">
        <b-form @submit.prevent="currentPage = goPage">
          <b-form-group>
            <b-input-group prepend="Go to page:">
              <b-form-input
                type="number"
                min="1"
                v-model="goPage"
              ></b-form-input>
              <b-input-group-append
                ><b-button variant="db-sb" @click="currentPage = goPage"
                  >Go</b-button
                ></b-input-group-append
              >
            </b-input-group>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="confirmDelete" hide-footer hide-header>
      <div class="d-block text-center">
        <h3 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="color: red; margin-right:5px" :icon="['fas', 'trash']" />
          Project deletion
        </h3>
      </div>
      <p style="line-height:normal">Please confirm permanent deletion of project: <strong v-if="projectToDelete !== null">{{projectToDelete.name}}</strong>. <br>It cannot be recovered.</p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-3 col-5"
          variant="quanteec"
          @click="
            deleteSelected();
            hideModal('confirmDelete');
          "
          >
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'trash']" />
          Delete
        </b-btn>
        <b-btn
          class="col-md-3 col-5"          
          @click="hideModal('confirmDelete')"
          variant="quanteeclg"
          >
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          Cancel
        </b-btn>
      </b-row>
    </b-modal>

  </div>
</template>

<script>
let moment = require("moment");
import { EventBus } from "@/event-bus.js";
import ProjectService from "@/services/project.service.js";
import UserService from "@/services/user.service.js";
import TeamService from "@/services/team.service.js";
import { BASE_URL, BASE_READER, EMBED_URL, WS_VIREED } from "@/services/base-url";
import FadeLoader from "vue-spinner/src/FadeLoader.vue";
import io from "socket.io-client";
import VideoMethods from "@/services/vireedAnnotation.service";

let projectService = new ProjectService();
var uService = new UserService();
let tService = new TeamService();
var vMethods = new VideoMethods();
let ws_vireed = WS_VIREED;

export default {
  name: "vireed",
  components: {
    FadeLoader,
  },
  data: function () {
    return {
      teamsTable: [
        { key: "teamname", label: "Team", sortable: true },
        { key: "descriptionTeam", label: "Description" },
        { key: "owner", label: "Owner" },
        { key: "actions", label: "Actions" },
      ],
      collabsTable: [
        { key: "collabName", label: "Team", sortable: true },
        { key: "collabRole", label: "Role" },
        { key: "collabActions", label: "Actions" },
      ],
      roles: ["admin", "editor", "viewer"],
      projects: [],
      teams: [],
      baseurl: BASE_READER,
      newCollabName: "",
      collabNameState: null,
      teamName: "",
      teamNameState: null,
      teamDescription: "",
      invalidFeedbackCollab: "Collaborator's username is required",
      collaborators: [],
      teamSelected: "",
      usersList: [],
      thOrList: 0,
      projectToDelete: null,

      //SEARCH PARAM
      search: "",
      oldSearch: "",
      searchParameters: {},
      isGetInProgress: false,
      timeoutSearchDuration: 2,
      sortMsg: "",

      //PAGE
      totalNumberOfPage: 1000000,
      realTotalNumberOfPage: 1000000,
      currentPage: 1,
      goPage: 1,
      numberPerPage: 100,
      lastGetWithPage: false,
      numberOfProjects: 0,
      totalNumberOfProjects: 0,

      //SORT PROJECT
      activeSort: "createdDate",
      activeSortOrder: -1,
      mySort: { createdDate: -1 },
    };
  },
  methods: {
    getProjects: function (page) {
      this.isGetInProgress = true;
      let search = JSON.stringify(this.searchParameters);
      var page = page || this.currentPage;
      var params = {
        page: page,
        pagesize: this.numberPerPage,
        sort: this.mySort,
      };

      if (search && search !== "{}") {
        params.search = search;
      }

      projectService
        .getProjects(this.$auth.token(), params)
        .then((projects) => {
          this.projects = projects._embedded;
          this.numberOfProjects = projects.size;

          this.totalNumberOfPage = Math.ceil(
            this.numberOfProjects / this.numberPerPage
          );
          this.realTotalNumberOfPage = Math.ceil(
            this.numberOfProjects / this.numberPerPage
          );
          for (let project in this.projects) {

            this.projects[project]._modifyTitle = false;
            this.projects[project].createdAt = moment(
              this.projects[project].createdDate
            ).format("DD/MM/YY @HH:mm");

            if (this.projects[project].lastUpdated)
              this.projects[project].lastUpdatedFormat = moment(
                this.projects[project].lastUpdated
              ).format("DD/MM/YY @HH:mm");

            var lastIdxVersion = -1;

            if(this.projects[project].manifestVideo === undefined)
            {
              this.projects[project].manifestVideo = {
                thumbnail: this.projects[project].videoData[0].customThumbnailPath || this.projects[project].videoData[0].thumbnail || "",
              }
            }

            for (var i = this.projects[project].versions.length-1; i >= 0; i--) {
              if (!this.projects[project].versions[i].deleted && lastIdxVersion === -1) {
                lastIdxVersion = i;
              }
            }
            
            this.projects[project].lastVersion =
              this.projects[project].versions[lastIdxVersion].number;
            this.projects[project].uuidLastVersion =
              this.projects[project].versions[lastIdxVersion].uuidVideo;

            var idxVideoLastVersion = this.projects[
              project
            ].videoData.findIndex(
              (video) => video.uuid === this.projects[project].uuidLastVersion
            );
            if (idxVideoLastVersion > -1) {
              this.projects[project].videoTitleLastVersion =
                this.projects[project].videoData[idxVideoLastVersion].title;

              projectService
                .getAnnotationProjectVersion(
                  this.projects[project].uuid,
                  this.projects[project].lastVersion
                )
                .then((res) => {
                  var annotations = res.data;
                  this.projects[project].annotations = 0;
                  this.projects[project].comments = 0;
                  this.projects[project].annotationsWithComments = 0;

                  annotations.forEach((annot) => {
                    this.projects[project].annotations =
                      this.projects[project].annotations + 1;

                    if (annot.comments.length > 1) {
                      this.projects[project].annotationsWithComments =
                        this.projects[project].annotationsWithComments + 1;
                      this.projects[project].comments =
                        this.projects[project].comments +
                        annot.comments.length -
                        1;
                    }
                  });
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          }
          this.isGetInProgress = false;
          this.getNumberProjectPlatform();
        })
        .catch((error) => {
          this.isGetInProgress = false;
        });
    },

    changeActiveSort(value) {
      var sortObject = {};
      if (value !== this.activeSort) {
        this.activeSortOrder = 1;
        this.activeSort = value;
      } else {
        this.activeSortOrder = this.activeSortOrder === 1 ? -1 : 1;
      }
      this.saveSortParameters();
      sortObject[this.activeSort] = this.activeSortOrder;
      this.mySort = JSON.stringify(sortObject);
      this.getProjects();
    },

    saveSortParameters() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem("Vireed_sortparam", this.activeSort);
        searchStorage.setItem(
          "Vireed_sortorder",
          this.activeSortOrder === 1 ? "asc" : "desc"
        );
      } catch (err) {}
    },

    getSortParameters() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.sort = searchStorage.getItem("Vireed_sortparam");
        result.sortOrder = searchStorage.getItem("Vireed_sortorder");
        if (result.sortOrder === "asc") {
          result.sortOrder = 1;
        } else {
          result.sortOrder = -1;
        }
      } catch (err) {}

      return result;
    },

    getTeams() {
      tService.getTeams(this.$auth.token()).then((teams) => {
        this.teams = teams;
      });
    },

    imgUrlAlt(event, video) {
      try {
        if (video.type === "live") {
          event.target.src = `/thumbnaillive.jpg`;
        } else if (video.encodingStatus === "encoding") {
          event.target.src = `/thumbnail2.jpg`;
        } else {
          event.target.src = `/thumbnail.jpg`;
        }
      } catch(err) {
        event.target.src = `/thumbnail.jpg`;
      }
    },

    startProject(project) {
      this.$router.push("/vireed/" + project.uuid + "/" + project.lastVersion);
    },

    resetModal() {
      this.newCollabName = "";
      this.collabNameState = null;
      this.teamName = "";
      this.teamNameState = null;
      this.teamDescription = "";
      this.collaborators = [];
    },

    loadModal() {
      this.usersList = [];
      this.newCollabName = "";
      this.collabNameState = null;
      this.teamName = "";
      this.teamNameState = null;
      this.teamDescription = "";
      this.collaborators = [];

      uService.getUsers(this.$auth.token()).then((users) => {
        users.forEach((user) => {
          this.usersList.push(user.username);
        });
      });
    },

    addCollab() {
      if (!this.newCollabName) {
        this.invalidFeedbackCollab = "Collaborator's username is required";
        this.collabNameState = false;
        return;
      }

      uService
        .getUser(this.$auth.token(), this.newCollabName)
        .then((response) => {
          this.collabNameState = true;
          let newCollab = {
            username: this.newCollabName,
            role: "viewer",
          };
          this.collaborators.push(newCollab);
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.invalidFeedbackCollab =
              "User " + this.newCollabName + " not found";
            this.collabNameState = false;
          }
        });
    },

    addCollabEdit() {
      if (!this.newCollabName) {
        this.invalidFeedbackCollab = "Collaborator's username is required";
        this.collabNameState = false;
        return;
      }

      uService
        .getUser(this.$auth.token(), this.newCollabName)
        .then((response) => {
          this.collabNameState = true;
          let newCollab = {
            username: this.newCollabName,
            role: "viewer",
          };
          this.teamSelected.collabsTeam.push(newCollab);
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.invalidFeedbackCollab =
              "User " + this.newCollabName + " not found";
            this.collabNameState = false;
          }
        });
    },

    createTeam(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (!this.teamName) {
        this.teamNameState = false;
        return;
      }

      let body = JSON.stringify({
        name: this.teamName,
        description: this.teamDescription,
        group: this.collaborators,
      });

      tService
        .createTeam(this.$auth.token(), body)
        .then((response) => {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-new-team");
            this.getTeams();
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },

    deleteTeam() {
      let socket = io(ws_vireed, {});

      socket.on("connect", () => {
        //socket.emit("room")
      });

      //On récupère les projets contenant l'équipe que l'on veut supprimer
      projectService
        .getProjectsFromTeam(this.$auth.token(), this.teamSelected.uuid)
        .then((responseProjects) => {
          //On supprime bien l'équipe en question
          tService
            .deleteTeam(this.$auth.token(), this.teamSelected.uuid)
            .then((response) => {
              this.getTeams();
              //To-Do : Envoyer l'info comme quoi la team a été "retiré du projet"
              responseProjects.forEach((project) => {
                let socket = io(ws_vireed, {});

                socket.on("connect", () => {
                  //On se positionne dans la room correspondant au projet
                  socket.emit("roomManage", project.uuid);
                });

                socket.on("connectedToRoom", () => {
                  socket.emit("teamRemove");
                  socket.disconnect();
                });
              });
            })
            .catch((err) => {
              console.log(err);
            });
        });
    },

    editTeam() {
      let team = {
        teamName: this.teamSelected.teamName,
        teamDescription: this.teamSelected.teamDescription,
        collabsTeam: this.teamSelected.collabsTeam,
      };

      team = JSON.stringify(team);

      //On récupère les projets avec l'équipe modifiée
      projectService
        .getProjectsFromTeam(this.$auth.token(), this.teamSelected.uuid)
        .then((responseProjects) => {
          tService
            .updateTeam(this.$auth.token(), this.teamSelected.uuid, team)
            .then((response) => {
              responseProjects.forEach((project) => {
                let socket = io(ws_vireed, {});

                socket.on("connect", () => {
                  //On se positionne dans la room correspondant au projet
                  socket.emit("roomManage", project.uuid);
                });

                socket.on("connectedToRoom", () => {
                  socket.emit("teamEdit");
                  socket.disconnect();
                });
              });
              this.getTeams();
            })
            .catch((err) => {
              console.log(err);
            });
        });
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
    removeUser(idx) {
      this.teamSelected.collabsTeam.splice(idx, 1);
    },
    emitNewProject() {
      EventBus.$emit("projectForm");
    },
    startTimeoutSearch() {
      try {
        clearTimeout(this.timeoutSearch);
      } catch (e) {}

      if (this.oldSearch !== this.search) {
        this.isGetInProgress = true;
        this.timeoutSearch = setTimeout(
          this.onSearchBar,
          this.timeoutSearchDuration * 1000
        );
      } else {
        this.isGetInProgress = false;
      }
    },
    onSearchBar() {
      try {
        clearTimeout(this.timeoutSearch);
      } catch (e) {}

      let words = this.search.toLowerCase().split(" ");

      this.oldSearch = this.search;
      this.searchParameters = {};
      this.searchParameters["$and"] = [];

      for (let word of words) {
        if (word.startsWith("author:") || word.startsWith("owner:")) 
        {
          let owner = word.split(":")[1].split("+");
          if (owner.length > 1) {
            this.searchParameters["$and"].push({ user: { $in: owner } });
          } else {
            this.searchParameters["$and"].push({ user: word.split(":")[1] });
          }
        }else if (word.startsWith("description:")) {
          let decription = word.split(":")[1].split("+");
          decription = decription.map((elem) => {
            return "(?i)^.*" + elem + ".*";
          });
          if (decription.length > 1) {
            this.searchParameters["$and"].push({
              description: { $regex: decription.join("|") },
            });
          } else {
            this.searchParameters["$and"].push({
              description: { $regex: decription[0] },
            });
          }
        } else if (word.startsWith("title:")) 
          {
          let title = word.split(":")[1].split("+");
          title = title.map((elem) => {
            return "(?i)^.*" + elem + ".*";
          });
          if (title.length > 1) {
            this.searchParameters["$and"].push({
              name: { $regex: title.join("|") },
            });
          } else {
            this.searchParameters["$and"].push({
              name: { $regex: title[0] },
            });
          }
        } else {
          var objTest = { $regex: "(?i)^.*" + word + ".*" };
          this.searchParameters["$and"].push({
            $or: [{ name: objTest }, { description: objTest }, {owner: objTest}],
          });
        }
      }
          
      this.currentPage = 1;
      this.getProjects();
    },
    getNumberProjectPlatform() {
      projectService
        .getProjects(this.$auth.token(), {
          pagesize: 0,
          sort: this.mySort,
        })
        .then((projects) => {
          this.totalNumberOfProjects = projects._size;
        });
    },
    saveListParam() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem("Vireed_list", this.thOrList);
      } catch (err) {}
    },
    getListParam() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.thOrList = searchStorage.getItem("Vireed_list");
        result.thOrList = +result.thOrList;
      } catch (err) {}

      return result;
    },
    deleteSelected() {
      if (this.projectToDelete != null || this.projectToDelete != undefined) {
        projectService
          .deleteProject(this.$auth.token(), this.projectToDelete.uuid)
          .then((res) => {
            let socket = io(ws_vireed, {});

            socket.on("connect", () => {
              //On se positionne dans la room correspondant au projet
              socket.emit("roomManage", this.projectToDelete.uuid);
            });

            socket.on("connectedToRoom", () => {
              socket.emit("projectDeleted", this.projectToDelete.uuid);
              socket.disconnect();
            });

            this.getProjects();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    updateTitle(project) {
      projectService
        .putProjectById(
          this.$auth.token(),
          { name: project._title },
          project.uuid
        )
        .then(() => {
          project._modifyTitle = false;
          project.name = project._title;
          this.projects = this.projects.splice(0);
        })
        .catch((err) => {});
    },
    updateDescription(project) {
      projectService
        .putProjectById(
          this.$auth.token(),
          { description: project._desc },
          project.uuid
        )
        .then(() => {
          project._modifyDescription = false;
          project.description = project._desc;
          this.projects = this.projects.splice(0);
        })
        .catch((err) => {});
    },
  },
  mounted() {
    let storageSort = this.getSortParameters();
    let storageList = this.getListParam();
    let self = this;

    this.activeSort = storageSort.sort || this.activeSort;
    this.activeSortOrder =
      storageSort.sortOrder !== null && storageSort.sortOrder !== undefined
        ? storageSort.sortOrder
        : this.activeSortOrder;

    this.mySort = JSON.stringify({ [this.activeSort]: this.activeSortOrder });

    this.thOrList =
      storageList.thOrList !== null &&
      storageList.thOrList !== undefined &&
      !isNaN(storageList.thOrList)
        ? storageList.thOrList
        : +this.thOrList;

    this.getProjects();

    EventBus.$on("reloadProjectsList", this.getProjects);
  },
  computed: {
    activeSortMsg() {
      switch (this.activeSort) {
        case '':
          this.sortMsg = "none";
          break;
        case 'createdDate':
          this.sortMsg = "date of creation";
          break;
        case 'nameLowerCase':
          this.sortMsg = "title";
          break;
        case 'user':
          this.sortMsg = "project owner";
          break;
        case 'error':
          this.sortMsg = "processing error(s)";
          break;
        case 'lastUpdated':
          this.sortMsg = "date of last update";
          break;
        case 'rebuff':
          this.sortMsg = "rebuffering %";
          break;
        case 'offload':
          this.sortMsg = "efficiency %";
          break;
        case 'dataDelivered':
          this.sortMsg = "data delivered";
          break;
        case 'concurrentUsers':
          this.sortMsg = "concurrent viewers";
          break;
        case 'energySaved':
          this.sortMsg = "% of energy saved";
          break;
        case 'kwhSpent':
          this.sortMsg = "KWh spent";
          break;
        case 'co2Spent':
          this.sortMsg = "CO2 rejected";
          break;
        case 'nbView':
          this.sortMsg = "views number";
          break;
        case 'hourview':
          this.sortMsg = "viewing hours";
          break;
        case 'meanTime':
          this.sortMsg = "mean viewing duration";
          break;
        case 'chapters.length':
          this.sortMsg = "presence of chapters";
          break;
        case 'type':
          this.sortMsg = "video type";
          break;
        case 'download':
          this.sortMsg = "downloadable feature";
          break;
        case 'uploadingPercent':
          this.sortMsg = "uploading %";
          break;
        case 'encodingPercent':
          this.sortMsg = "encoding %";
          break;
        case 'uploadingETA':
          this.sortMsg = "uploading remaining time";
          break;
        case 'encodingETA':
          this.sortMsg = "encoding remaining time";
          break;

        default:
          this.sortMsg = this.activeSort;
      }
      return this.sortMsg;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.scrollmenu {
  display: flex;
  justify-content:center;
  overflow: auto;
  white-space: nowrap;
  padding-left:30px;
}

@media (min-width: 768px) {
  .greysearch {
    border: 0.125rem solid;
    border-radius: 10px;
    padding: 10px 10px;
    margin: -10px -10px;
    border-color: #2a5d77;
  }
}

.greysearch {
  margin: 0px 0px;
}

.previewContainer {
  position: relative;
  width: 100%;
  margin-bottom: 0.5rem;
  padding-top: 56.25%;
  background-color: black;
}

.previewContainer2 {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  background-color: black;
}

.previewImg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.scrolling-box {
  overflow-y: scroll;
  scroll-behavior: smooth;
  height:calc(100vh - 60px);
  margin:0px;
}

</style>